import React from 'react';
import { useNavigate } from 'react-router-dom';

const NeckCervicalPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .neck-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #e0f2fe 0, #f9fafb 45%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .neck-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .neck-hero {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 28px;
          padding-bottom: 36px;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .neck-hero-left {
          flex: 1 1 280px;
        }

        .neck-hero-right {
          flex: 1 1 260px;
          display: flex;
          justify-content: center;
        }

        .neck-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(37, 99, 235, 0.12);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 10px;
        }

        .neck-tag-dot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #1d4ed8;
        }

        .neck-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .neck-subtitle {
          font-size: 15px;
          max-width: 540px;
          line-height: 1.5;
          color: #4b5563;
        }

        .neck-hero-highlights {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 14px 0 16px;
        }

        .neck-pill {
          padding: 6px 10px;
          border-radius: 999px;
          background: rgba(15, 23, 42, 0.9);
          color: #f9fafb;
          font-size: 11px;
        }

        .neck-cta-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 8px;
        }

        .neck-btn-primary,
        .neck-btn-secondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .neck-btn-primary {
          background: #2563eb;
          color: #f9fafb;
          box-shadow: 0 10px 24px rgba(37, 99, 235, 0.35);
        }

        .neck-btn-primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
        }

        .neck-btn-secondary {
          background: rgba(15, 23, 42, 0.05);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .neck-btn-secondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .neck-hero-small {
          font-size: 11px;
          margin-top: 10px;
          color: #6b7280;
        }

        .neck-hero-image {
          width: 100%;
          max-width: 420px;
          border-radius: 26px;
          object-fit: cover;
        }

        /* STRIPES (FULL WIDTH BANDS) */
        .neck-stripe {
          padding: 30px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.5);
        }

        .neck-sectionTitle {
          font-size: 19px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .neck-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .neck-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .neck-flexCol {
          flex: 1 1 260px;
        }

        .neck-inlineImage {
          width: 100%;
          max-width: 380px;
          border-radius: 22px;
          object-fit: cover;
        }

        .neck-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 7px;
        }

        .neck-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .neck-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #2563eb;
          flex-shrink: 0;
        }

        /* “3 TILE” INFO STRIP */
        .neck-triplet {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 18px;
          margin-top: 16px;
        }

        .neck-tile {
          padding: 12px 14px;
          border-radius: 20px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.4);
        }

        .neck-tileTitle {
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .neck-tileText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE / PROGRESSION */
        .neck-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
          margin-top: 12px;
        }

        .neck-step {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .neck-stepLabel {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .neck-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* FULL-WIDTH BANNER W/ IMAGE */
        .neck-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 18px;
        }

        .neck-banner img {
          width: 100%;
          height: 230px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .neck-banner img {
            height: 270px;
          }
        }

        .neck-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.75), transparent 55%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .neck-bannerText {
          color: #e5e7eb;
          font-size: 15px;
          max-width: 420px;
        }

        .neck-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .neck-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .neck-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .neck-bannerButtons .secondary {
          background: rgba(15, 23, 42, 0.35);
          color: #f9fafb;
          border: 1px solid rgba(209, 213, 219, 0.7);
        }

        /* BOTTOM WARNING STRIP */
        .neck-bottomStrip {
          margin-top: 26px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .neck-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .neck-bottomText strong {
          color: #fef9c3;
        }

        .neck-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .neck-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .neck-bottomActions .primary {
          background: #2563eb;
          color: #f9fafb;
        }

        .neck-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        /* RESPONSIVE */
        @media (max-width: 640px) {
          .neck-title {
            font-size: 26px;
          }
          .neck-hero {
            padding-bottom: 28px;
          }
        }
      `}</style>

      <div className="neck-page">
        <div className="neck-inner">
          {/* ===== HERO ===== */}
          <section className="neck-hero">
            <div className="neck-hero-left">
              <div className="neck-tag">
                <span className="neck-tag-dot" />
                Neck / Cervical Spine Relief
              </div>
              <h1 className="neck-title">
                Relieve neck tension and restore easy movement.
              </h1>
              <p className="neck-subtitle">
                The cervical spine supports your head, protects nerves, and guides everyday motion.
                When it&apos;s irritated, you feel it with every look, turn, or screen glance.
              </p>

              <div className="neck-hero-highlights">
                <span className="neck-pill">Stiff or “locked” neck</span>
                <span className="neck-pill">Pain turning or looking up</span>
                <span className="neck-pill">Neck-related headaches</span>
                <span className="neck-pill">Numbness or tingling into the arm</span>
              </div>

              <div className="neck-cta-row">
                <button
                  className="neck-btn-primary"
                  onClick={() => navigate('/appointments')}
                >
                  Book a neck / cervical visit →
                </button>
                <button
                  className="neck-btn-secondary"
                  onClick={() => navigate('/staff')}
                >
                  Meet our therapists
                </button>
              </div>

              <p className="neck-hero-small">
                Not sure if PT is right for your neck? You can always start with a one-time evaluation
                and decide from there.
              </p>
            </div>

            <div className="neck-hero-right">
              <img
                src="/content/neck-cervical/neck_cervical_hero.jpg"
                alt="Physical therapist supporting a patient’s neck and upper spine"
                className="neck-hero-image"
              />
            </div>
          </section>

          {/* ===== STRIPE 1: COMMON NECK / CERVICAL ISSUES ===== */}
          <section className="neck-stripe">
            <div className="neck-sectionTitle">What can go wrong in the neck / cervical spine?</div>
            <p className="neck-sectionSubtitle">
              The neck is a busy area: vertebrae, discs, nerves, and muscles all stack in a small space.
              When something gets irritated, it often shows up in everyday movements.
            </p>

            <div className="neck-flexRow">
              <div className="neck-flexCol">
                <ul className="neck-list">
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Muscle tension in the scalenes:</strong> tightness along the side of the neck
                      that can add pressure or a &quot;ropey&quot; feeling.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>SCM (sternocleidomastoid) irritation:</strong> pain in the front / side of the neck
                      that can connect to headaches or eye pressure.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Joint stiffness:</strong> trouble turning your head when backing up a car
                      or checking blind spots.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Poor posture strain:</strong> long hours with the head forward over a phone
                      or laptop, creating ongoing neck fatigue.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Radiating symptoms:</strong> tingling, numbness, or achiness that runs from the neck
                      into the shoulder, arm, or hand.
                    </span>
                  </li>
                </ul>

                <div className="neck-cta-row" style={{ marginTop: '14px' }}>
                  <button
                    className="neck-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    See if your neck symptoms fit →
                  </button>
                  <button
                    className="neck-btn-secondary"
                    onClick={() => navigate('/contact')}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="neck-flexCol" style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/neck-cervical/neck_cervical_posture.jpg"
                  alt="Person sitting with poor and corrected neck posture at a desk"
                  className="neck-inlineImage"
                />
              </div>
            </div>

            <div className="neck-triplet">
              <div className="neck-tile">
                <div className="neck-tileTitle">Everyday triggers</div>
                <div className="neck-tileText">
                  Long drives, phone scrolling, heavy bags, or sleeping in one position can all add up.
                </div>
              </div>
              <div className="neck-tile">
                <div className="neck-tileTitle">Cervical spine + nerves</div>
                <div className="neck-tileText">
                  Irritated joints or discs may send signals down into the shoulder, arm, or hand.
                </div>
              </div>
              <div className="neck-tile">
                <div className="neck-tileTitle">Neck + headache link</div>
                <div className="neck-tileText">
                  Tight muscles and stiff joints at the top of the neck often connect directly to head pain.
                </div>
              </div>
            </div>
          </section>

          {/* ===== STRIPE 2: HOW PT HELPS (MANUAL FOCUS) ===== */}
          <section className="neck-stripe">
            <div className="neck-flexRow">
              <div className="neck-flexCol" style={{ order: 2 }}>
                <div className="neck-sectionTitle">How physical therapy helps the neck / cervical spine</div>
                <p className="neck-sectionSubtitle">
                  We combine hands-on work, guided motion, and small habit changes to calm irritation
                  and get the neck moving comfortably again.
                </p>

                <ul className="neck-list">
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Gentle joint mobilization:</strong> small, controlled movements to help
                      stiff cervical joints glide better.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Soft-tissue work:</strong> focused treatment to scalenes, SCM, and upper trapezius
                      to ease that “tight band” feeling.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Movement coaching:</strong> simple ways to turn, look up, or check blind spots
                      that place less strain on the neck.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Posture resets:</strong> realistic adjustments for desk, car seat,
                      and phone use that you can actually keep up with.
                    </span>
                  </li>
                  <li>
                    <span className="neck-bullet" />
                    <span>
                      <strong>Targeted strengthening:</strong> building support in the deep neck and shoulder
                      muscles to handle your day.
                    </span>
                  </li>
                </ul>

                <div className="neck-cta-row" style={{ marginTop: '14px' }}>
                  <button
                    className="neck-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Start with one neck session →
                  </button>
                  <button
                    className="neck-btn-secondary"
                    onClick={() => navigate('/insurance')}
                  >
                    Check insurance coverage
                  </button>
                </div>
              </div>

              <div className="neck-flexCol" style={{ order: 1, display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/neck-cervical/neck_cervical_manual.jpg"
                  alt="Manual therapy to the neck and cervical spine"
                  className="neck-inlineImage"
                />
              </div>
            </div>
          </section>

          {/* ===== STRIPE 3: WHAT A VISIT LOOKS LIKE + EXERCISES IMAGE ===== */}
          <section className="neck-stripe">
            <div className="neck-flexRow">
              <div className="neck-flexCol">
                <img
                  src="/content/neck-cervical/neck_cervical_exercises.jpg"
                  alt="Patient performing guided neck exercises with a physical therapist"
                  className="neck-inlineImage"
                />
              </div>

              <div className="neck-flexCol">
                <div className="neck-sectionTitle">What a neck / cervical visit might look like</div>
                <p className="neck-sectionSubtitle">
                  Your plan is always tailored, but most sessions follow a simple, predictable flow:
                </p>

                <div className="neck-timeline">
                  <div className="neck-step">
                    <div className="neck-stepLabel">1. Conversation & history</div>
                    <div className="neck-stepText">
                      You describe where the pain is, what makes it worse, and what you&apos;re hoping to do better.
                    </div>
                  </div>
                  <div className="neck-step">
                    <div className="neck-stepLabel">2. Gentle testing</div>
                    <div className="neck-stepText">
                      We check neck motion, posture, and key muscles like the scalenes and SCM.
                    </div>
                  </div>
                  <div className="neck-step">
                    <div className="neck-stepLabel">3. Hands-on relief</div>
                    <div className="neck-stepText">
                      You try one or two manual techniques or stretches to see how your neck responds.
                    </div>
                  </div>
                  <div className="neck-step">
                    <div className="neck-stepLabel">4. Short home plan</div>
                    <div className="neck-stepText">
                      You leave with a small group of movements and posture tips that fit your day.
                    </div>
                  </div>
                </div>

                <div className="neck-cta-row" style={{ marginTop: '14px' }}>
                  <button
                    className="neck-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Book a neck / cervical eval →
                  </button>
                  <button
                    className="neck-btn-secondary"
                    onClick={() => navigate('/contact')}
                  >
                    Talk to our team first
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BANNER: CLINIC SPACE (REUSE HEAD/SKULL CLINIC OR ANOTHER) ===== */}
          <section className="neck-stripe">
            <div className="neck-banner">
              {/* You can reuse your clinic environment image if you like */}
              <img
                src="/content/head-skull/clinic_environment.jpg"
                alt="Calm physical therapy clinic environment"
              />
              <div className="neck-bannerOverlay">
                <div className="neck-bannerText">
                  Sessions are one-on-one and focused. We keep the space calm so your neck muscles
                  have a chance to let go of tension instead of bracing more.
                </div>
                <div className="neck-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Schedule my neck visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate('/office')}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BOTTOM WARNING ===== */}
          <section className="neck-stripe">
            <div className="neck-bottomStrip">
              <div className="neck-bottomText">
                If your neck pain is sudden after trauma, comes with serious weakness, trouble speaking,
                vision changes, or loss of balance,{" "}
                <strong>seek emergency or medical care immediately.</strong> Physical therapy fits into your
                care plan after urgent issues are ruled out.
              </div>
              <div className="neck-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate('/appointments')}
                >
                  Schedule neck / cervical PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate('/contact')}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default NeckCervicalPT;
